import { Pipe, PipeTransform } from '@angular/core';
import { isNil, Nillable } from '@web/utils';
import { TableColumn } from '../models/table-column';

@Pipe({
  name: 'columnKeyCssClass',
  standalone: true,
})
export class ColumnKeyCssClassPipe<Item, Filter> implements PipeTransform {
  public transform(
    column: Nillable<TableColumn<Item, Filter>>,
  ): Nillable<string> {
    if (isNil(column)) {
      return;
    }

    const key = String(column.key);

    return `column-key-${key}`;
  }
}
